import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import t from './MultiProductSelect.type';
import { getMultiProductTestingLibs } from '../../../../../services/product-testing';
import { fetchMultipleExchangeRateService, getBomForMultipleProducts, multiProductCostingAdd } from '../../../../../services/product-costing.service';
import { ERROR_MESSAGE } from '../../../../../Components/helper';

export const getProductInfoList = (prodInfo, supplierInfo) => async (dispatch) => {
  try {
    const data = { prodInfo, supplierInfo };
    await dispatch({
      type: t.SET_ALL_PRODUCT_DETAILS,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductTestingLibs = (data) => async (dispatch) => {
  try {
    const res = await getMultiProductTestingLibs(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_ALL_PRODUCT_TESTING_LIBS,
        payload: res.data,
      });
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductBOMLibs = (data) => async (dispatch) => {
  try {
    const res = await getBomForMultipleProducts(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_ALL_PRODUCT_BOM_COMPS,
        payload: res.data,
      });
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getExchangeRateList = (data) => async (dispatch) => {
  try {
    const res = await fetchMultipleExchangeRateService(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_ALL_EXCHANGE_RATES,
        payload: res.data,
      });
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setCurrentProductData = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_CURRENT_PRODUCT_DATA,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const setFirstSelectionData = (type, data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FIRST_SELECTION_DATA,
      payload: { type, data },
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addMultiProductCosting = (data) => async () => {
  try {
    const res = await multiProductCostingAdd(data);
    if (res?.code === 200) {
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const clearMultipleCostingReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_REDUCER_MULTIPLE_COSTING,
      payload: {},
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
